<template>
   <div class="advMain" id="page6">
     <div class="leftBlock">
       <h3 class="title">让裂变复购更简单</h3>
       <p class="message">
         通过涿溪防窜货营销复购功能，用户复购过程中，全程绑定在码内，无需担心用户流失在其他渠道，同时由此裂变的用户也会与产品涿溪防窜货绑定，裂变复购简单安全、路径统一。
       </p>
       <div class="buttonWrap"><Mybutton @clickFn="showForm">了解裂变复购</Mybutton></div>
     </div>
     <div class="rightBlock">
       <transition name="lb-img">
        <img class="lb_img" v-show="buyShow" src="../assets/images/lb_1.png" />
       </transition>
       <transition name="lb-img">
        <img class="lb_img" v-show="buyShow" src="../assets/images/lb_2.png" />
       </transition>
       <transition name="lb-img">
        <img class="lb_img" v-show="buyShow" src="../assets/images/lb_3.png" />
       </transition>
       <transition name="lb-img">
        <img class="lb_img" v-show="buyShow" src="../assets/images/lb_4.png" />
       </transition>
       <transition name="lb-img">
        <img class="lb_img" v-show="buyShow" src="../assets/images/lb_5.png" />
       </transition>
       <transition name="lb-img">
        <img class="lb_img" v-show="buyShow" src="../assets/images/lb_6.png" />
       </transition>
       <transition name="lb-img">
        <img class="lb_img" v-show="buyShow" src="../assets/images/lb_7.png" />
       </transition>
     </div>
   </div>
</template>
<script>
import Mybutton from './Mybutton'
export default {
  name: 'codeBuy',
  components: {
    Mybutton
  },
  props: {
    buyShow: Boolean
  },
  data () {
    return {

    }
  },
  methods: {
    showForm () {
      this.$emit('changeVisible', true)
    }
  }
}
</script>
<style scoped lang="scss">

.lb-img-enter-active {
  animation: lb-in-out .8s;
  animation-delay: .1s;
}
.lb-img-leave-active {
  animation: lb-in-out .3s reverse;
  animation-delay: 0;
}

@keyframes lb-in-out {
  0% {
    opacity: 0.3;
    transform: scale(0.1) rotate(360deg);
  }
  60% {
    opacity: 0.5;
    transform: scale(1.2) rotate(180deg);
  }
  100%{
    opacity: 1;
    transform: scale(1) rotate(0);
  }
}

  .advMain{
    padding: 12% 100px 45px;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    .leftBlock{
      .title{
        font-size: 40px;
        font-family: PingFang-SC-Medium, PingFang-SC;
        font-weight: normal;
        color: #1F2329;
        line-height: 56px;
      }
      .message{
        font-size: 18px;
        font-family: PingFang-SC-Regular, PingFang-SC;
        font-weight: normal;
        color: #36444D;
        line-height: 28px;
        width: 400px;
      }
      .buttonWrap{
        margin-top: 50px;
      }
    }
    .rightBlock{
      width: 450px;
      height: 450px;
      background: url('../assets/images/bg_5.png') top left no-repeat;
      position: relative;
      img:nth-child(1) {
        position: absolute;
        top: 78px;
        left: 106px;
      }
      img:nth-child(2) {
        position: absolute;
        top: 67px;
        left: 310px;
      }
      img:nth-child(3) {
        position: absolute;
        top: 221px;
        left: 398px;
      }
      img:nth-child(4) {
        position: absolute;
        top: 321px;
        left: 335px;
      }
      img:nth-child(5) {
        position: absolute;
        left: 214px;
        bottom: 59px;
      }
      img:nth-child(6) {
        position: absolute;
        left: 95px;
        bottom: 95px;
      }
      img:nth-child(7) {
        position: absolute;
        left: 10px;
        top: 213px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/CodeBuy.vue